<template src="./pinboard-media.html"></template>

<script lang="ts">
import formatName from 'filters/format-name'
import { getImageUrl, TYPE_PHOTO } from 'util/media-utils'

export default {
  props: {
    media: {
      type: Object,
      required: true
    }
  },
  computed: {
    altText() {
      if (this.media.caption) {
        return this.media.caption
      } else if (this.media.user) {
        return this.$msg('media.submittedBy', [formatName(this.media.user)])
      }
      const type = this.media.type === TYPE_PHOTO ? 'photo' : 'video'
      return this.$msg(`media.forSubmission.${type}`)
    },
    isImage() {
      return this.media.type === TYPE_PHOTO
    },
    imageSrc() {
      if (this.isImage) {
        return getImageUrl(this.media, 'LW600')
      }
      return this.media.thumbnailUrl // video
    }
  }
}
</script>

<style lang="scss" src="./pinboard-media.scss"></style>
